var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_42_1",
    "data-name": "Component 42 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 16,
    viewBox: "0 0 11.5 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_41_1",
    "data-name": "Component 41 \\u2013 1",
    transform: "translate(0.63 2.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M5.546,5.333l.983,12.113A1.22,1.22,0,0,0,7.75,18.667h5.875a1.22,1.22,0,0,0,1.221-1.221l.971-12.113ZM8.113,16.375,7.833,6.667H8.6l.287,9.708H8.113Zm2.929,0h-.75V6.667h.75Zm2.179,0h-.775l.283-9.708H13.5Z",
    transform: "translate(-5.546 -5.333)",
    opacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M15.167,3.833h-1.5l-1.1-.958a.845.845,0,0,0-.55-.209h-2.7a.857.857,0,0,0-.558.209l-1.1.958h-1.5c-.734,0-1.25.35-1.25,1.083h11.5c0-.734-.517-1.083-1.25-1.083Z",
    transform: "translate(-4.917 -2.667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c2e63ad0e4580688b203482ed1781a96.svg";
export { ForwardRef as ReactComponent };